import { c as _c } from "react/compiler-runtime";
import { Button } from '@repo/design-system/components/ds/button';
import { FlexRow } from '@repo/design-system/components/layout/flex-row';
import { Modal } from '@repo/design-system/components/ui/modal';
import { useT } from '@repo/i18n/components/i18n.client';
import type React from 'react';
interface DeleteChecklistConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  isDeleting?: boolean;
}
export const DeleteChecklistConfirmModal: React.FC<DeleteChecklistConfirmModalProps> = t0 => {
  const $ = _c(28);
  const {
    isOpen,
    onClose,
    onConfirm,
    isDeleting: t1
  } = t0;
  const isDeleting = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["game_map"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useT(t2);
  let t3;
  if ($[1] !== onClose) {
    t3 = details => {
      if (!details.open) {
        onClose();
      }
    };
    $[1] = onClose;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t) {
    t4 = t(_temp);
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = t(_temp2);
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t) {
    t6 = t(_temp3);
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isDeleting || $[10] !== onClose || $[11] !== t6) {
    t7 = <Button onClick={onClose} color="secondary" size="md" disabled={isDeleting}>{t6}</Button>;
    $[9] = isDeleting;
    $[10] = onClose;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t(_temp4);
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== isDeleting || $[16] !== onConfirm || $[17] !== t8) {
    t9 = <Button onClick={onConfirm} color="primary" size="md" disabled={isDeleting}>{t8}</Button>;
    $[15] = isDeleting;
    $[16] = onConfirm;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t9) {
    t10 = <FlexRow gap="8" justify="end" width="full">{t7}{t9}</FlexRow>;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== isOpen || $[23] !== t10 || $[24] !== t3 || $[25] !== t4 || $[26] !== t5) {
    t11 = <Modal isOpen={isOpen} onOpenChange={t3} title={t4} description={t5} size="sm">{t10}</Modal>;
    $[22] = isOpen;
    $[23] = t10;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
};
function _temp($) {
  return $.save_checklist.delete_list;
}
function _temp2($_0) {
  return $_0.save_checklist.delete_confirm_description;
}
function _temp3($_1) {
  return $_1.save_checklist.cancel;
}
function _temp4($_2) {
  return $_2.save_checklist.delete_list;
}